export default __webpack_public_path__ + "static/media/no-message-vector.785ca439.svg";